function checkResizeObserver() {
  try {
    if (typeof window.ResizeObserver === "undefined" || !window.ResizeObserver) {
      throw new Error("ResizeObserver is not defined");
    }
  } catch (_e) {
    console.warn();
    console.warn(`Attention: your browser doesn't support "ResizeObserver".`);
    console.warn(
      `Please see https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver#browser_compatibility for more information.`
    );
    console.warn();
  }
}
export {
  checkResizeObserver
};
//# sourceMappingURL=checkResizeObserver.js.map
